import digitalData from 'digital-data';
import {
  makeEverythingLowerCase,
  setAnalytics
} from '../../../thd-analytics-utils';

export function landingPage() {
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('landing-page.page-load', ({ output }) => {
    const {
      title,
    } = output;

    digitalData.page = {
      pageInfo: {
        abTest: 'landing-page:version:gen2',
        pageLoadEvent: 'content',
        pageName: title,
        pageTemplate: 'default',
        pageType: 'content',
      },
      category: {
        primaryCategory: title,
        subCategory1: title,
        subCategory2: title,
      }
    };

    digitalData.page.pageInfo = makeEverythingLowerCase(digitalData?.page?.pageInfo);
    digitalData.page.category = makeEverythingLowerCase(digitalData?.page?.category);

    setAnalytics(digitalData);
  });

}